import { render, staticRenderFns } from "./SalesDetailsByItem.vue?vue&type=template&id=16613b34&scoped=true&"
import script from "./SalesDetailsByItem.vue?vue&type=script&lang=js&"
export * from "./SalesDetailsByItem.vue?vue&type=script&lang=js&"
import style0 from "./SalesDetailsByItem.vue?vue&type=style&index=0&id=16613b34&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16613b34",
  null
  
)

export default component.exports